import { baseApi } from './baseApi';

/**
 * Orders API endpoints
 * Handles CRUD operations for order management
 */
export const ordersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /orders - Fetch all orders
    getOrders: builder.query({
      query: () => '/orders',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ order_id }) => ({ type: 'Order', id: order_id })),
              { type: 'Order', id: 'LIST' },
            ]
          : [{ type: 'Order', id: 'LIST' }],
    }),

    // GET /orders/:id - Fetch order by ID
    getOrderById: builder.query({
      query: (id) => `/orders/${id}`,
      providesTags: (result, error, id) => [{ type: 'Order', id }],
    }),

    // POST /orders - Create new order
    createOrder: builder.mutation({
      query: (orderData) => ({
        url: '/orders',
        method: 'POST',
        body: orderData,
      }),
      invalidatesTags: [{ type: 'Order', id: 'LIST' }],
    }),

    // PUT /orders/:id - Update order
    updateOrder: builder.mutation({
      query: ({ id, ...orderData }) => ({
        url: `/orders/${id}`,
        method: 'PUT',
        body: orderData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Order', id },
        { type: 'Order', id: 'LIST' },
      ],
    }),

    // DELETE /orders/:id - Delete order
    deleteOrder: builder.mutation({
      query: (id) => ({
        url: `/orders/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Order', id },
        { type: 'Order', id: 'LIST' },
      ],
    }),

    // POST /orders/convert - Convert proposal to order
    convertProposalToOrder: builder.mutation({
      query: (proposalId) => ({
        url: '/orders/convert',
        method: 'POST',
        body: { proposal_id: proposalId },
      }),
      invalidatesTags: [
        { type: 'Order', id: 'LIST' },
        { type: 'Proposal', id: 'LIST' },
      ],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetOrdersQuery,
  useGetOrderByIdQuery,
  useCreateOrderMutation,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
  useConvertProposalToOrderMutation,
} = ordersApi;

